<template>
    <div>
        <!-- EMPRESAS LISTADAS NA TABELA/DETALHES -->
        <b-modal id="modal-log-detalhado"
            ref="modalLogDetalhado"
            title="Log detalhado"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            ok-only
            ok-title="fechar"
            scrollable
            v-drag>
                <el-card v-loading="loading" class="box-card w-100">
                    <b-card class="w-100 mb-2">
                        <p class="p-0 m-0"> <small>Número: </small> <b><i>{{ datas.referenciaExterna }}</i></b> </p>
                        <el-button v-if="datas.notas" class="cursor-pointer" icon="el-icon-warning-outline" circle size="mini" type="danger" @click.native="showNotas(datas.notas)" style="position: absolute;right: 5px;top: 7px;"></el-button>
                    </b-card>
                    <div> 
                        <!-- TABLE -->
                        <el-table
                            class="p-table"
                            :data="datas.sincronizacoesFilhas || []"
                            style="width: 100%"
                            stripe
                            size="mini">

                            <el-table-column 
                                prop="referenciaExterna"
                                label="Número"
                                align="center"
                                width="100">
                            </el-table-column>

                            <el-table-column
                                prop="empresa"
                                label="Empresa"
                                align="left">
                            </el-table-column>

                            <el-table-column
                                prop="periodo"
                                label="Período"
                                align="center"
                                width="130">
                            </el-table-column>

                            <el-table-column
                                fixed="right"
                                label="Status"
                                width="70"
                                align="center">
                                <template slot-scope="scope" v-if="scope.row">
                                    <el-tooltip v-if="scope.row.status === 'Aguardando'" class="item" effect="dark" content="Status: Aguardando" placement="top-start">
                                        <i class="fas fa-circle text-warning"></i>
                                    </el-tooltip>
                                    <el-tooltip v-if="scope.row.status === 'Processando'" class="item" effect="dark" content="Status: Processando" placement="top-start">
                                        <i class="fas fa-circle text-primary"></i>
                                    </el-tooltip>
                                    <el-tooltip v-if="scope.row.status === 'Finalizado'" class="item" effect="dark" content="Status: Finalizado" placement="top-start">
                                        <i class="fas fa-circle text-success"></i>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            
                        </el-table>

                    </div>
                    <el-footer class="text-center" style="padding-top:13px;">
                        <el-pagination
                            class="text-center"
                            background
                            layout="prev, pager, next, sizes"
                            @size-change="paginacaoSize"
                            @current-change="paginacaoCurrent"
                            :page-size="pagination.pageSize"
                            :current-page.sync="pagination.page"
                            :total="modalData.total"
                            :page-sizes="[5, 10, 25, 50]">
                        </el-pagination>
                    </el-footer>
                </el-card>
                <template #modal-footer="{ hide }">
                    <div class="float-right">
                        <el-button size="small" @click="hide()">Fechar</el-button>
                    </div>
                </template>
        </b-modal>
    </div>
</template>
<script>
export default {
    data(){
        return {
            modalData: {}
        }
    },
    name: 'modal-log-detalhado',
    props:['datas','pagination','loading'],
    methods:{
        computedClass(index) {
            if (index % 2 === 0) {
                return "col-md-4"
            }
        },
        showNotas(numero, notas) {
            const notasHtml = () => {
                let html = '';
                for(let i = 0; i < notas.length; i++){
                    html += `<p>${notas[i]}</p>`;
                }
                return html;
            }
            let htmlFormated = `<div class="row">
                        <div class="col-md-12">
                            ${notasHtml()}
                        </div>
                        <div>`;
            this.$alert(htmlFormated, 'Notas', { dangerouslyUseHTMLString: true });
        },
        cellStyle(row) {
            if(row.columnIndex === 0){
                return !row.row.notas ? 'remove-controle-notas' : '';
            }
            
        },
        paginacaoCurrent(val){
            this.$root.$emit('paginationDetalheCurrent', { id: this.modalData.id, p: val });
        },
        paginacaoSize(val){
            this.$root.$emit('paginationDetalheSize', { id: this.modalData.id, p: val });
        }
    },
    watch: {
        datas: {
            deep: true,
            handler(dt){
                this.modalData = dt;
            }
        }
    }
}
</script>
<style lang="scss">
    .card-empresas-container{
        max-height:250px; 
        overflow-y:auto; 
        width:100%;
        &::-webkit-scrollbar-track{
            box-shadow: inset 0 0 6px rgba(54, 54, 54, 0.3);
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar{
            width: 6px;
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar-thumb{
            background-color: #5e5e5e;
        }
    }
    .filtro-empresas{
        padding: 0px;
        margin: 5px 0;
        margin-top: -9px;
    }
    .card-empresas{
        transition:0.2s;
        padding: 5px 6px !important;
        cursor: pointer;
        .el-card {
            padding: 3px;
        }
        .selected {
            background: #7dbde2 !important;
        }
        &:hover{
            background:#f1f1f1;
        }
    }
    .table-lista-empresas{
        tr{
            &:nth-child(odd){
                background: #fff;
            }
            &:nth-child(even){
                background: #f4fafd;
            }
        }
    }
    td.remove-controle-notas {
        opacity: 0;
        visibility: hidden;
    }
</style>